function sendSessionStorage(key) {
  if (key === "getSessionStorage") {
    localStorage.setItem("sessionStorage", sessionStorage.getItem("auth-credential"));
    localStorage.removeItem("sessionStorage");
  }
}

function transferSessionStorage(key) {
  if(key === "sessionStorage") {
    var data = event.newValue;
    sessionStorage.setItem("auth-credential", data);
  }
}

function removeSessionStorage(key) {
  if(key === "removeSessionStorage") {
    sessionStorage.clear();
  }
}

var sessionStorageTransfer = function(event) {
  if(!event) { event = window.event; }
  if(!event.newValue) { return; }

  sendSessionStorage(event.key);
  transferSessionStorage(event.key);
  removeSessionStorage(event.key);
};

if(window.addEventListener) {
  window.addEventListener("storage", sessionStorageTransfer, false);
}

if (!sessionStorage.length) {
  localStorage.setItem("getSessionStorage", "startProcess");
  localStorage.removeItem("getSessionStorage");
}


// WEBPACK FOOTER //
// src/transfer-session.js